import * as React from "react"
const DownloadSvgComponent  = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 1024 1024",
    }}
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      d="M135.2 71.6h656c12.2 0 22.1 9.9 22.1 22.1v603.4H113.1V93.7c0-12.2 9.9-22.1 22.1-22.1z"
      style={{
        fill: "#f8ef90",
      }}
    />
    <path
      d="M782.3 740.7H145.6c-19.1 0-35.6-13.1-39.9-31.7L.9 261c-4.8-20.4 10.7-39.9 31.6-39.9h430.7l76.3 91.4h352.4c21.5 0 37.1 20.6 31.2 41.3l-101.4 357c-4.9 17.7-21 29.9-39.4 29.9z"
      style={{
        fill: "#f5bb19",
      }}
    />
    <path
      d="M663.2 653.7h-45.5c-2.2 0-4-1.8-4-4s1.8-4 4-4h45.5c2.2 0 4 1.8 4 4s-1.8 4-4 4zm-113.7 0H504c-2.2 0-4-1.8-4-4s1.8-4 4-4h45.5c2.2 0 4 1.8 4 4s-1.8 4-4 4zm-113.8 0h-45.5c-2.2 0-4-1.8-4-4s1.8-4 4-4h45.5c2.2 0 4 1.8 4 4s-1.8 4-4 4zm-113.8 0h-45.5c-2.2 0-4-1.8-4-4s1.8-4 4-4h45.5c2.2 0 4 1.8 4 4s-1.8 4-4 4zm-113.8 0h-45.5c-2.2 0-4-1.8-4-4s1.8-4 4-4h45.5c2.2 0 4 1.8 4 4s-1.8 4-4 4z"
      style={{
        fill: "#f9cc4b",
      }}
    />
    <path
      d="M809 948.2c118.7 0 215-96.2 215-215s-96.2-215-215-215-215 96.2-215 215 96.3 215 215 215z"
      style={{
        fill: "#37b34a",
      }}
    />
    <path
      d="m906.1 767.4-80 88.8c-9.1 10.1-25.1 10.1-34.2 0L712 767.4c-12.6-14-2.7-36.3 16.2-36.3h35.3v-103c0-11.9 9.6-21.5 21.5-21.5h48c11.9 0 21.5 9.6 21.5 21.5v103H890c18.8 0 28.7 22.3 16.1 36.3z"
      style={{
        fill: "#f6f0e0",
      }}
    />
  </svg>
)
export default DownloadSvgComponent;
